import { render, staticRenderFns } from "./resolve.vue?vue&type=template&id=5fdf2f1b&scoped=true&"
import script from "./resolve.vue?vue&type=script&lang=js&"
export * from "./resolve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf2f1b",
  null
  
)

export default component.exports